import{icon as e}from"@godown/element";const t=e(`0 0 256 256`)`<path fill="currentColor" d="M165.66 202.34a8 8 0 0 1-11.32 11.32l-80-80a8 8 0 0 1 0-11.32l80-80a8 8 0 0 1 11.32 11.32L91.31 128Z">`;export{t as default};
//# sourceMappingURL=caret-left.js.map
